import { render } from "./FormColorpicker.vue?vue&type=template&id=763c8eca"
import script from "./FormColorpicker.vue?vue&type=script&lang=js"
export * from "./FormColorpicker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-management\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__